/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { ICookieMgr } from "@microsoft/applicationinsights-core-js";
import {
    IAppInsights,
    IAutoExceptionTelemetry,
    IEventTelemetry,
    IExceptionTelemetry,
    IMetricTelemetry,
    IPageViewPerformanceTelemetry,
    IPageViewTelemetry,
    ITraceTelemetry,
} from "@microsoft/applicationinsights-web";
import { CustomProperties } from "./ITelemetryClient";

export default class DisabledApplicationInsights implements IAppInsights {
    public getCookieMgr(): ICookieMgr {
        return {
            setEnabled: (value: boolean) => {},
            isEnabled: () => false,
            set: (name: string, value: string, maxAgeSec?: number, domain?: string, path?: string) => true,
            get: (name: string) => "",
            del: (name: string, path?: string) => true,
            purge: (name: string, path?: string) => true,
        };
    }

    public trackEvent(event: IEventTelemetry, customProperties?: CustomProperties): void {}

    public trackPageView(pageView: IPageViewTelemetry, customProperties?: CustomProperties): void {}

    public trackException(
        exception: IExceptionTelemetry,
        customProperties?: CustomProperties
    ): void {}

    public _onerror(exception: IAutoExceptionTelemetry): void {}

    public trackTrace(trace: ITraceTelemetry, customProperties?: CustomProperties): void {}

    public trackMetric(metric: IMetricTelemetry, customProperties?: CustomProperties): void {}

    public startTrackPage(name?: string): void {}

    public stopTrackPage(name?: string, url?: string, customProperties?: Object): void {}

    public startTrackEvent(name: string): void {}

    public stopTrackEvent(name: string, properties?: Object, measurements?: Object): void {}

    public addTelemetryInitializer(
        telemetryInitializer: (
            item: import("@microsoft/applicationinsights-web").ITelemetryItem
        ) => boolean | void
    ): void {}

    public trackPageViewPerformance(
        pageViewPerformance: IPageViewPerformanceTelemetry,
        customProperties?: CustomProperties
    ): void {}
}
